import React from "react";

const PopText = ({ text, name, color, main }) => {
  return (
    <div
      className={`self-end inline-flex flex-col w-auto relative mt-3 ${
        main && "pr-4 md:pr-20 lg:pr-32"
      }`}
    >
      <div
        className="rounded-full px-4 py-2 inline-block self-end z-20"
        style={{
          background: color,
          marginBottom: -5,
        }}
      >
        <p className="text-white text-xs">{name}</p>
      </div>
      <div className="self-start bg-white rounded-2xl p-3 inline-block z-10">
        <p className="text-xs">{text}</p>
      </div>
    </div>
  );
};

export default PopText;
